// extracted by mini-css-extract-plugin
module.exports = {"CardGroup":"CardGroup_CardGroup__3tToh","CardGroupInner":"CardGroup_CardGroupInner__1E2K9","CardGroupList":"CardGroup_CardGroupList__xV3MN"};